<template>
  <div>
    <h3 class="title is-4" style="margin-top: 15px;">Live Lessons</h3>
    <b-tabs
      :animated="false"
      type="is-boxed"
      size="is-medium"
      v-show="getProfile && getProfile.isAdmin"
    >
      <b-tab-item label="Beginner">
        <LiveLessonsTable :lessons="beginner" level="beginner" />
      </b-tab-item>
      <b-tab-item label="Intermediate">
        <LiveLessonsTable :lessons="intermediate" level="intermediate" />
      </b-tab-item>
      <b-tab-item label="Advanced">
        <LiveLessonsTable :lessons="advanced" level="advanced" />
      </b-tab-item>
    </b-tabs>

    <p v-show="getProfile && !getProfile.isAdmin">
      Live lessons are coming soon!
    </p>
  </div>
</template>

<script>
import { firestore } from "@/services/firebase";
import LiveLessonsTable from "@/components/LiveLessonsTable";
import { mapGetters } from "vuex";

export default {
  name: "liveLessons",
  components: { LiveLessonsTable },
  computed: {
    ...mapGetters(["getProfile"]),
  },
  data() {
    return {
      beginner: [],
      intermediate: [],
      advanced: [],
    };
  },
  firestore: {
    beginner: firestore
      .collection("live_lessons")
      .doc("beginner")
      .collection("lessons"),
    intermediate: firestore
      .collection("live_lessons")
      .doc("intermediate")
      .collection("lessons"),
    advanced: firestore
      .collection("live_lessons")
      .doc("advanced")
      .collection("lessons"),
  },
};
</script>

<style scoped>
td {
  border: 1px solid lightgray;
  padding: 10px;
}
</style>
